export default __webpack_public_path__ + "static/media/sightXicon.0d9acd30.png";